import React from "react";

const Content = ({ children }) => {
  return <div className="w-9/12 border-l pl-10 relative">{children}</div>;
};

export default Content;
